import React from 'react';
import './style.css';

const NextButton = ({ onNextLevel, messNext }) =>  {
  
    let classes = 'button-q w-button mbut button_next';
    // let btnDisabled = false;
    // if (nextActive) classes += ' btn-next';
    // else btnDisabled = true;

    return (
      <button 
        type='button'
        // disabled={btnDisabled}
        className={classes}
        onClick={onNextLevel}>
          {messNext}
      </button>

    );
  
}

export default NextButton;
